import React from 'react';
import styled from 'styled-components';
import { COLOR, FONT_SIZE, SPACING } from '../../../constants/theme';

const Item = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${SPACING.md};
  padding: ${SPACING.md} 0;
  border-bottom: 1px solid ${COLOR.border};

  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }

  &:first-child {
    padding-top: 0;
  }
`;

const Marker = styled.span`
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin-top: 1px;
  border-radius: 50%;
  background: ${COLOR.primaryLight};
  color: ${COLOR.primary};
  font-size: 12px;
  font-weight: 700;
`;

const Body = styled.div`
  min-width: 0;
`;

const Title = styled.div`
  font-size: ${FONT_SIZE.value};
  font-weight: 500;
  line-height: 1.45;
  color: ${COLOR.text};
`;

const Detail = styled.div`
  margin-top: 2px;
  font-size: ${FONT_SIZE.body};
  line-height: 1.55;
  color: ${COLOR.textSecondary};

  a {
    color: ${COLOR.primary};
  }
`;

const renderDetail = ({ detail, linkLabel, linkUrl }) => {
  const linkStartIndex =
    linkLabel && linkUrl ? String(detail).indexOf(linkLabel) : -1;

  if (linkStartIndex < 0) return detail;

  const textBeforeLink = String(detail).slice(0, linkStartIndex);
  const textAfterLink = String(detail).slice(linkStartIndex + linkLabel.length);

  return (
    <>
      {textBeforeLink}
      <a href={linkUrl} target="_blank" rel="noopener noreferrer">
        {linkLabel}
      </a>
      {textAfterLink}
    </>
  );
};

const NextSteps = ({ steps = [] }) => (
  <div>
    {steps.map((step, index) => (
      <Item key={step.key}>
        <Marker>{index + 1}</Marker>
        <Body>
          <Title>{step.title}</Title>
          {step.detail && <Detail>{renderDetail(step)}</Detail>}
        </Body>
      </Item>
    ))}
  </div>
);

export default NextSteps;
